<template>
  <h1 class="not-found-title">404</h1>
  <p class="not-found-text">Page not found</p>
  <svg
    class="not-found-smile"
    stroke="currentColor"
    fill="none"
    stroke-width="0"
    viewBox="0 0 24 24"
    height="200"
    width="200"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9 11C9.55228 11 10 10.5523 10 10C10 9.44772 9.55228 9 9 9C8.44772 9 8 9.44772 8 10C8 10.5523 8.44772 11 9 11Z"
      fill="currentColor"
    ></path>
    <path
      d="M14 17C14 15.8954 13.1046 15 12 15C10.8954 15 10 15.8954 10 17H8C8 14.7909 9.79086 13 12 13C14.2091 13 16 14.7909 16 17H14Z"
      fill="currentColor"
    ></path>
    <path
      d="M16 10C16 10.5523 15.5523 11 15 11C14.4477 11 14 10.5523 14 10C14 9.44772 14.4477 9 15 9C15.5523 9 16 9.44772 16 10Z"
      fill="currentColor"
    ></path>
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12Z"
      fill="currentColor"
    ></path>
  </svg>
</template>
<script>
export default {
  name: 'NotFound',
  props: {
    addMessage: { type: Function, required: true },
  },
};
</script>
<style>
.not-found-title {
  margin: 0;
  text-align: center;
  font-size: 100px;
}

.not-found-text {
  margin: 0;
  text-align: center;
  font-size: 50px;
}

.not-found-smile {
  margin: 0 auto;
  display: block;
  color: rgba(0, 0, 0, 0.87);
  text-align: center;
}
</style>
